import React, { FC, memo } from 'react';
import ScenarioSwitch from '@components/Headers/core/ScenarioSwitch';
import { useProject } from '@context/Project/ProjectProvider';
import { Divider, Stack } from '@mui/material';
import { themePalette } from '@theme/muiTheme';
import { AdditionalSettings } from '@views/Project/components/AdditionalSettings/AdditionalSettings';
import DashboardFilters from '@views/Project/components/Toolbox/components/DashboardFilters';
import LinkButton from '@views/Project/components/Toolbox/components/LinkButton';
import ModelFilters from '@views/Project/components/Toolbox/components/ModelFilters';
import ModesDropdown from '@views/Project/components/Toolbox/components/ModesDropdown';
import ScopeFilter from '@views/Project/components/Toolbox/components/ScopeFilter';
import useToolboxLinks from '@views/Project/components/Toolbox/hooks/useToolboxLinks';
import { LinksWrapper } from '@views/Project/components/Toolbox/Toolbox.styled';

const Toolbox: FC = () => {
  const { isVersionsShown, isDashboardMode } = useProject();
  const isProjectLinksDisabled = isVersionsShown;

  const { toolboxLinks, handleLinkClick } = useToolboxLinks();

  return (
    <>
      <Stack
        p={6}
        direction="row"
        justifyContent="space-between"
        borderBottom={`1px solid ${themePalette.grey[500]}`}
      >
        <Stack gap={4} direction="row" alignItems="center">
          <ModesDropdown />

          <ScopeFilter />

          <Divider orientation="vertical" flexItem />

          <LinksWrapper $disabled={isProjectLinksDisabled}>
            {toolboxLinks.map((linkItem) => (
              <LinkButton
                key={linkItem.label}
                item={linkItem}
                onClick={(e) => handleLinkClick(e, linkItem.to)}
              />
            ))}
          </LinksWrapper>

          <Divider orientation="vertical" flexItem />

          {isDashboardMode ? <DashboardFilters /> : <ModelFilters />}

          <AdditionalSettings />
        </Stack>

        <ScenarioSwitch />
      </Stack>
    </>
  );
};

export default memo(Toolbox);
